/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import * as THREE from "three";
import { useGLTF, useAnimations, useTexture } from "@react-three/drei";
import model from "./Industria_V6.glb";
import luminariaEmissive from "./materials/Luminarias-emissive.png";
import Pipe from "./Pipe";

export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(model);
  const luminariaEmissiveTexture = useTexture(luminariaEmissive);
  const { actions } = useAnimations(animations, group);
  Object.entries(materials).forEach(([key, value]) => {
    value.envMapIntensity = props.envMapIntensity;
  });
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Silo"
          geometry={nodes.Silo.geometry}
          material={materials.Silo}
          material-metalness={0.5}
          position={[-14.02, 2.09, -60.96]}
          scale={[4.06, 2.12, 4.06]}
        />
        <mesh
          name="Plataformas"
          geometry={nodes.Plataformas.geometry}
          material={materials.Plataformas}
          position={[-14.02, 7.05, -60.96]}
          scale={[1.92, 1, 1.92]}
        />
        <mesh
          name="Escada"
          geometry={nodes.Escada.geometry}
          material={materials.Escada}
          position={[-14.13, 20.49, -56.79]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={0.16}
        />
        <mesh
          name="Lona"
          geometry={nodes.Lona.geometry}
          material={materials.Lona_Bake}
          material-roughness={1}
          position={[0.97, 6.76, -23.99]}
          scale={[1.04, 0.15, 1]}
        />
        <mesh
          name="Gerador_A"
          geometry={nodes.Gerador_A.geometry}
          material={materials.Gerador_A}
          position={[-3.03, 0.03, -22.2]}
        />
        <mesh
          name="Gerador_B"
          geometry={nodes.Gerador_B.geometry}
          material={materials.Gerador_B}
          position={[-3.03, 0.03, -30.48]}
        />
        <mesh
          name="Tanque"
          geometry={nodes.Tanque.geometry}
          material={materials.Tanque}
          material-normalMap={null}
          position={[7.71, 6.13, -68.61]}
          rotation={[0, -0.28, 0]}
        >
          <mesh
            name="Infrastructure"
            geometry={nodes.Infrastructure.geometry}
            material={materials.Epoxi}
            position={[4.88, -2.4, -5.86]}
          />
        </mesh>
        <Pipe />
        <mesh
          name="PipeStation"
          geometry={nodes.PipeStation.geometry}
          material={materials.PipeStation}
          position={[25.63, -0.02, -62.46]}
          scale={3.01}
        />
        <mesh
          name="Patio"
          geometry={nodes.Patio.geometry}
          material={materials.Patio}
          position={[11.23, 0, -60.83]}
        />
        <mesh
          name="Piso"
          geometry={nodes.Piso.geometry}
          material={materials.Piso_Bake}
          material-roughness={0.45}
          material-metalness={0}
          material-emissive={new THREE.Color("#cccccc")}
          material-emissiveMap={luminariaEmissiveTexture}
          material-emissiveMap-flipY={false}
          envMapIntensity={0}
          position={[0.81, -0.04, -23.65]}
        />
        <mesh
          name="Paredes"
          geometry={nodes.Paredes.geometry}
          material={materials.Paredes}
          material-roughness={1}
          material-metalness={1}
          position={[6.83, 4.08, -22.14]}
        />
        <mesh
          name="Janelas"
          geometry={nodes.Janelas.geometry}
          material={materials.Janelas}
          position={[8.62, 4.49, -23.32]}
        />
        <mesh
          name="EstruturaTelhado"
          geometry={nodes.EstruturaTelhado.geometry}
          material={materials.EstruturaTelhado}
          position={[1, 6.48, -18.93]}
        />
        <mesh
          name="Luminarias"
          geometry={nodes.Luminarias.geometry}
          material={materials.Luminarias}
          material-emissive-intensity={10}
          position={[6.17, 5.18, -14.74]}
        />
        <mesh
          name="ParedeFundo"
          geometry={nodes.ParedeFundo.geometry}
          material={materials.ParedeFundo}
          position={[0.37, 2.73, -12.22]}
          scale={[1, 1.02, 1]}
          rotation={[Math.PI, 0, Math.PI]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
